import React from "react";
import {
  SpotlightCardHolder,
  SpotlightFooter,
  SpotlightMedia,
  SpotlightTitle,
} from "./SpotlightCard.styles";

interface IItem {
  mediaName: string;
  heading: string;
  date: string;
  link: string;
}

interface ISpotlightCard {
  footerArrow: string;
  item: IItem;
}

const SpotlightCard = ({ item, footerArrow }: ISpotlightCard) => {
  const { mediaName, heading, date, link } = item;

  return (
    <SpotlightCardHolder>
      {mediaName && (
        <SpotlightMedia href={link} target="_blank">
          {mediaName}
        </SpotlightMedia>
      )}
      {heading && (
        <SpotlightTitle>
          <a href={link} target="_blank" rel="noopener noreferrer">
            {heading}
          </a>
        </SpotlightTitle>
      )}
      <SpotlightFooter>
        {date && <p>{date}</p>}
        <a href={link} target="_blank" rel="noopener noreferrer">
          <img src={footerArrow} alt="" />
        </a>
      </SpotlightFooter>
    </SpotlightCardHolder>
  );
};

export default SpotlightCard;
